import React from "react";

const CityUnloading = () => {
    return (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_13300_60404)">
        <path d="M9.33594 1.83594H1.33594V15.1693H14.6693V8.68927L10.0026 7.13327L9.33594 7.35527V1.83594ZM8.0026 7.79994L5.33594 8.6886V13.8359H2.66927V3.16927H8.0026V7.79994ZM6.66927 13.8359V9.64927L10.0026 8.5386L13.3359 9.64994V13.8359H10.6693V11.1693H9.33594V13.8359H6.66927Z" fill="#252525"/>
        <path d="M13 1.16406V5.83073M13 1.16406L15 3.16406M13 1.16406L11 3.16406" stroke="#252525" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_13300_60404">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
        </clipPath>
        </defs>
        </svg>
              
    );
}

export default CityUnloading
